/**
 * 🗑️ 超管回收站（A6）· tech_admin only
 * 契约源：apps/api-server/src/api_server/routes/trash.py
 * - GET  /api/v1/admin/trash                              → TrashItem[]
 * - POST /api/v1/admin/trash/{entity_type}/{id}/restore   → RestoreResult
 * - POST /api/v1/admin/trash/purge                        → PurgeResult
 * 非 tech_admin → 403（前端也按角色隐藏 tab·双保险）
 */
import { api } from "./api";

export interface TrashItem {
  entity_type: string;   // order/product/driver/vehicle/hotel/attraction/supplier/channel_partner
  entity_label: string;  // 中文标签（订单/产品/…）
  id: string;
  summary: string;       // 业务摘要（订单号/名称…）
  deleted_at: string;    // ISO
  days_left: number;     // 距硬删剩余天数（0 = 今日到期）
}

export interface RestoreResult {
  entity_type: string;
  id: string;
  restored: boolean;
}

export interface PurgeResult {
  purged: number;
  by_type: Record<string, number>;
}

export const trashApi = {
  /** 列出 30 天内被软删的业务记录（按删除时间倒序） */
  list: () => api<TrashItem[]>("/api/v1/admin/trash"),
  /** 恢复一条软删记录（deleted_at = NULL） */
  restore: (entityType: string, id: string) =>
    api<RestoreResult>(`/api/v1/admin/trash/${entityType}/${id}/restore`, { method: "POST" }),
  /** 硬删 >30 天的到期记录 */
  purge: () => api<PurgeResult>("/api/v1/admin/trash/purge", { method: "POST" }),
};
